import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { RequestEndorse } from './shared/request-endorse.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-endorses',
  templateUrl: './endorses.component.html',
  styleUrls: ['./endorses.component.scss']
})
export class EndorsesComponent implements OnInit , OnChanges {
  displayedColumns: string[] = ['codigo', 'fecha', 'estudiante',
  'falcutad', 'programa', 'tipo', 'tipoSolicitud',
  'operaciones'];
dataSource: MatTableDataSource<RequestEndorse>;
@Input() requets: RequestEndorse[];


@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

constructor(private router: Router) {
            this.setTable();

}
ngOnInit() {
  this.setTable();
}
ngOnChanges() {
  this.setTable();
}

showDetail(row: RequestEndorse) {
  const param = JSON.stringify(row);
  this.router.navigate(['avales/materias'], { queryParams: { request : param  } });
}

private setTable() {
  this.dataSource = new MatTableDataSource(this.requets);
  this.dataSource.paginator = this.paginator;
  this.dataSource.sort = this.sort;
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }

}

}
